export const getVideoAspectRatio = (
  videoUrl: string,
  callback: (ratio: number) => void,
) => {
  const video = document.createElement('video');
  video.addEventListener('loadedmetadata', function () {
    const ratio = video.videoWidth / video.videoHeight;
    callback(ratio);
    video.remove();
  });

  video.src = videoUrl;
  video.load();
};

export const isValidUrl = (url: string | undefined) => {
  const extensionRegex = /\.([0-9a-z]+)(?:[?#]|$)/i;
  if (url && url.length > 0) {
    const match = url.match(extensionRegex);
    if (match) {
      const extension = match[1].toLowerCase();
      const validExtensions = ['mp4', 'webm', 'ogg', 'jpg'];
      return validExtensions.includes(extension);
    }
  }
  return false;
};
